import { render, staticRenderFns } from "./myindex.vue?vue&type=template&id=70918914&scoped=true&"
import script from "./myindex.vue?vue&type=script&lang=js&"
export * from "./myindex.vue?vue&type=script&lang=js&"
import style0 from "./myindex.vue?vue&type=style&index=0&id=70918914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70918914",
  null
  
)

export default component.exports